addEventListener('DOMContentLoaded', () => {
    const policy_container = document.querySelector('.shopify-policy__container'), 
          policy_content = document.createElement('div'),
          policy_block = document.createElement('div'),
          policy_block_container = document.createElement('div'),
          policy_block_visit = document.createElement('div'),
          policy_block_visit_icon = document.createElement('div'),
          policy_block_visit_text = document.createElement('div'),
          policy_block_contact = document.createElement('div'),
          policy_block_contact_text = document.createElement('div'),
          policy_block_contact_link = document.createElement('a'),
          policy_title = document.querySelector('.shopify-policy__title'),
          policy_body = document.querySelector('.shopify-policy__body');

    policy_content.className = 'shopify-policy__content';
    policy_block.className = 'shopify-policy__block';

    policy_container.appendChild(policy_content);
    policy_container.appendChild(policy_block);

    policy_content.appendChild(policy_title);
    policy_content.appendChild(policy_body);

    policy_block.appendChild(policy_block_container);
    policy_block_container.className = 'shopify-policy__block-container';

    policy_block_container.appendChild(policy_block_visit);
    policy_block_container.appendChild(policy_block_contact);

    policy_block_visit.className = 'shopify-policy__block-visit';

    policy_block_visit.appendChild(policy_block_visit_icon);
    policy_block_visit.appendChild(policy_block_visit_text);

    policy_block_visit_icon.className = 'shopify-policy__block-visit-icon';
    policy_block_visit_text.className = 'shopify-policy__block-visit-text';

    policy_block_contact.className = 'shopify-policy__block-contact';

    policy_block_contact.appendChild(policy_block_contact_text);
    policy_block_contact_text.className = 'shopify-policy__block-contact-text';

    policy_block_contact.appendChild(policy_block_contact_link);
    policy_block_contact_link.className = 'shopify-policy__block-contact-link';

    if (policy) {
        policy_block_visit_icon.innerHTML = policy.visit_icon;
        policy_block_visit_text.innerHTML = policy.visit_text;

        policy_block_contact_text.innerHTML = policy.contact_text;
        policy_block_contact_link.href = policy.contact_link;
        policy_block_contact_link.innerHTML = policy.contact_link_label;
    }

    async function fetchAndAppendGuaranteeSection() {
        try {
            const response = await fetch(policy.shop_url, {
                method: 'GET',
                mode: 'cors'
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const htmlText = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlText, 'text/html');
            const guaranteeSection = doc.querySelector('.section--guarantees');
            const mainContent = document.getElementById('MainContent');

            if (guaranteeSection && mainContent) {
                mainContent.appendChild(guaranteeSection);
            } else {
                console.warn('Not Found .section--guarantee or #MainContent in the fetched HTML.');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    fetchAndAppendGuaranteeSection();
})